import {
  ClientMatterDetails,
  DetailName,
  HeaderMetaChevron,
  HeaderMetaDetails,
  HeaderMetaSummary,
  HeaderMetaSummaryText,
  HeaderMetaBody,
  MemberCount,
} from '../../WorkspaceHeaderLayout.styles';

type Props = {
  clientLine?: string | null;
  matterLine?: string | null;
  memberCount?: number;
};

export const WorkspaceHeaderCompactMeta: React.FC<Props> = ({
  clientLine,
  matterLine,
  memberCount,
}) => {
  const hasClient = Boolean(clientLine);
  const hasMatter = Boolean(matterLine);
  const hasMembers = typeof memberCount === 'number' && memberCount > 0;

  if (!hasClient && !hasMatter && !hasMembers) {
    return null;
  }

  const summaryParts: string[] = [];
  if (hasClient) summaryParts.push('Client');
  if (hasMatter) summaryParts.push('Matter');
  if (hasMembers) {
    summaryParts.push(`${memberCount} member${memberCount !== 1 ? 's' : ''}`);
  }

  return (
    <HeaderMetaDetails>
      <HeaderMetaSummary>
        <HeaderMetaSummaryText>Details · {summaryParts.join(', ')}</HeaderMetaSummaryText>
        <HeaderMetaChevron aria-hidden>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </HeaderMetaChevron>
      </HeaderMetaSummary>
      <HeaderMetaBody>
        {(hasClient || hasMatter) && (
          <ClientMatterDetails $isCompact>
            {hasClient && <DetailName $isCompact>{clientLine}</DetailName>}
            {hasClient && hasMatter && <DetailName $isCompact> · </DetailName>}
            {hasMatter && <DetailName $isCompact>{matterLine}</DetailName>}
          </ClientMatterDetails>
        )}
        {hasMembers && (
          <MemberCount $isCompact>
            {memberCount} member{memberCount !== 1 ? 's' : ''}
          </MemberCount>
        )}
      </HeaderMetaBody>
    </HeaderMetaDetails>
  );
};
